/**
 * #335 — hazard-aware R.3 dispatch confirm label.
 *
 * The DispatchActions "Confirm Fire" button label + its "Fire confirmed" toast were
 * HARDCODED. DispatchActions renders for fire sources today (SOURCE_TO_INCIDENT_TYPE is
 * fire-only), but the hardcode is a latent landmine: the moment a non-fire hazard is
 * mapped into the dispatchable set it would inherit a FIRE word on a non-fire surface —
 * a per-surface Ontario IMS DOCTRINE-MISMATCH. This derives the operator-facing hazard
 * NOUN from IncidentWorkSurfaceSource.declareHazardType so the label is always correct.
 *
 * The fire noun is "Wildfire" (founder ruling — the hazard is wildfire, not "fire"). The
 * BACKEND identifiers are UNTOUCHED: recommendation_type stays 'confirm_fire' and the
 * verb stays 'confirm_fire_clicked' (operator-invisible; the per-surface rule permits a
 * backend term to differ from the UI). This module is UI-only.
 */

/** declareHazardType (IncidentHazardType) → operator NOUN. Only the three hazards that
 *  can plausibly reach a dispatch surface are named; everything else is the neutral
 *  "Hazard" (never a fire word). */
const CONFIRM_HAZARD_NOUN: Record<string, string> = {
  wildfire: 'Wildfire',
  flood: 'Flood',
  ice_storm: 'Ice Storm',
};

/** The operator-facing hazard noun for the confirm label/toast. */
export function confirmHazardNoun(hazardType?: string | null): string {
  if (!hazardType) return 'Hazard';
  return CONFIRM_HAZARD_NOUN[hazardType] ?? 'Hazard';
}

/** The confirm BUTTON label — "Confirm Wildfire" / "Confirm Flood" / "Confirm Ice Storm"
 *  / "Confirm Hazard". Never a fire word on a non-fire hazard. */
export function confirmHazardLabel(hazardType?: string | null): string {
  return `Confirm ${confirmHazardNoun(hazardType)}`;
}
